export default __webpack_public_path__ + "static/media/powered-by.eccfa7da.png";